export const getLoaderState = (state: any) => state.loader;
export const getAlertState = (state: any) => state.alert;
export const getUser = (state: any) => state.user;
export const getCurrentRoute = (state: any) => state.route;
export const getBusinessTypes = (state: any) => state.businessTypes;
